/* eslint-disable */
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "./Route";

const Authmiddleware = () => {
  // Here you can fetch the token from localStorage, Redux, or Context
  const token = localStorage.getItem("token");

  return (
    <Routes>
      {/* ====== non authenticated routes ====== */}
      {!token &&
        publicRoutes.map((routename, index) => (
          <Route
            key={index}
            path={routename.path}
            element={<routename.component />}
          />
        ))}

      {/* ====== authenticated routes ====== */}
      {token &&
        protectedRoutes.map((routename, index) => (
          <Route
            key={index}
            path={routename.path}
            element={<routename.component />}
          />
        ))}

      {/* ====== redirect rule ====== */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Authmiddleware;
